import { Component, Input } from '@angular/core';
import { AccordionData } from "../../..";
var HTML_TEMPLATE = "\n<div class=\"od-accordion-conversation-header\" >\n\t<od-conversation *ngIf=\"data != null\" class=\"od-accordion-conversation-header2\" [data]=\"data.data\"></od-conversation>\n\t<div [ngClass]=\"{'odi_dropdown': !data.expand, 'odi_breadcrumbsArrowTop':data.expand}\" style=\"top: 39px; right: 38px;\" ></div>\n</div>\n";
var CSS_STYLE = "\n.od-accordion-conversation-header{\n\tdisplay: contents;\n\tpadding: 10px;\n\twidth: 100%;\n\tmargin-right: 30px;\n}\n\n.od-accordion-conversation-header2{\n\tcursor:pointer;\n\tfont-weight: bold;\n\tfont-size: 20px;\n    width: calc(100% - 50px);\n}\n\n.odi_breadcrumbsArrowTop, .odi_dropdown {\n\tposition: absolute;\n    right: 40px;\n    color: #b7c0cd;\n    width: 10px;\n  \theight: 6px;\n}\n";
var AccordionConversationHeader = /** @class */ (function () {
    function AccordionConversationHeader() {
    }
    AccordionConversationHeader.decorators = [
        { type: Component, args: [{
                    selector: 'od-accordion-conversation-header',
                    template: HTML_TEMPLATE,
                    styles: [CSS_STYLE]
                },] },
    ];
    /** @nocollapse */
    AccordionConversationHeader.ctorParameters = function () { return []; };
    AccordionConversationHeader.propDecorators = {
        "data": [{ type: Input },],
    };
    return AccordionConversationHeader;
}());
export { AccordionConversationHeader };
//# sourceMappingURL=accordion-conversation-header.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui/chat/conversation/accordion-conversation-header.js
// module id = 452
// module chunks = 14